$('.footer-buttons').on('click',function(e){
  var toggle_ID = $(this).data('id');
  $('.footerdropdown[data-id="'+toggle_ID+'"]').slideToggle().siblings('.footerdropdown').slideUp();
  //$(this).toggleClass('active');
  $(this).toggleClass('active').closest('li').siblings().find('.footer-buttons').removeClass('active');
  $('.footer-weglot .country-selector').addClass('closed');
});
$('.footer-title').on('click',function(e){
  e.preventDefault();
  $(this).next('ul').slideToggle();
  $(this).toggleClass('active');
});
$('.ftrbtm-region li a').on('click',function(e){
  e.preventDefault();
  $(this).parent('li').addClass('active').siblings().removeClass('active');
  $('.ftrregionsave').attr('href',$(this).attr('href'));
  $(this).closest('.whiteftr-box').removeClass('active');
});
$('.fbcountryLink').on('click',function(e){
  e.preventDefault();
  $('.f-active-currency').text($(this).find('.top-svg').text());
});
$('.fcurrmcysave').on('click',function(e){
  $(this).closest('[data-loctype="currency"]').find('form').submit();
});
$('.locftrbutton').on('click',function(e){
  $('.whiteftr-box').removeClass('active');
  $('.whiteftr-box[data-loctype="'+$(this).attr('data-loctype')+'"]').addClass('active');
  return false;
});
$('#shopify-section-footer .moblocal-button').on('click',function(e){
  $('.whiteftr-box').removeClass('active');
});
$('body').on('click',function(e){   
  var seachbox = $(".locftrbutton,.whiteftr-box");    
  if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0){
    $('.whiteftr-box').removeClass('active');
  }
}); 
Weglot.on("languageChanged", function(e){
  $('[data-list="alanguage"]').slideUp();
  $('.footerdropdown[data-id="region-language"]').slideUp();
});